<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false">

    <div :class="{flex: true, 'use-login': SITE_CONFIG.use_login}">
      <div v-if="SITE_CONFIG.use_login">

        <h2 v-if="!loggedIn">{{ $t('user.login-title') }}</h2>

        <div class="blocked info">
          <!-- <b><icon name="info" :scale="1.4" /> {{ $t('user.login-subtitle') }}</b> -->
          <p v-html="$t('texts.texts-checkout_login_info')"></p>
        </div>

        <Login />

      </div>
      <div class="border">
        <div v-if="SITE_CONFIG.use_login">
          <h2 v-if="!loggedIn">{{ $t('user.login-go-on-anyway') }}</h2>
        </div>

        <div class="text" v-html="text"></div>

        <div class="choices">
          <div>
            <Checkbox v-if="!$store.state.isOnSite" label-position="after" :label="yes" :value="1" :valuebinder.sync="gdpr_newsletter" />
          </div>
          <div>
            <Checkbox v-if="!$store.state.isOnSite" label-position="after" :label="no" :value="0" :valuebinder.sync="gdpr_newsletter" />
          </div>
        </div>

        <div class="text" style="margin-bottom:8px;">
          Bokar du för ett företag, kontakta oss på <a href="tel:054132600" style="white-space: nowrap;">054-13 26 00</a>.
        </div>

        <div class="text" v-if="showCountrySelector" style="margin-bottom:8px;">
          <b>Select your country</b>
          <CountrySwitcher type="dropdown" :show-title="false" />
        </div>

        <button style="margin-top:8px;" :class="{small: true, disabled: !valid}" @click="click">{{$store.state.cart.pincode ? $t('user.send-order') : $t('user.to-payment')}}</button>

        <div style="margin-top:1.5rem;margin-bottom:1.5rem;" class="text" v-html="$t('texts.texts-gdpr_text')"></div>
      </div>
    </div>

  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import Login from '@/components/payments/Login';

import Checkbox from '@/components/components/Checkbox';

import CountrySwitcher from '@/components/components/CountrySwitcher';

import API from '@/classes/API';

import languageDetector from '@/mixins/languageDetector';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Login,
    Checkbox,
    CountrySwitcher,
  },
  data() {
    return {
      type: '',
      text: '',
      yes: '',
      no: '',
      gdpr_newsletter: null,
      showCountrySelector: false,
    };
  },
  async mounted() {
    if (this.$i18n.locale === this.SITE_CONFIG.languages.default) {
      localStorage.setItem('country', this.SITE_CONFIG.countries.default.toUpperCase());
    }

    const { type, text, yes, no } = await API.get('texts/general_gdpr_text');
    this.type = type;
    this.text = text;
    this.yes = yes;
    this.no = no;
  },
  mixins: [languageDetector],
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    valid() {
      if (this.gdpr_newsletter === 0 || this.gdpr_newsletter === 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    click() {
      this.$store.state.cart.gdpr = {};
      this.$store.state.cart.gdpr[this.type] = this.gdpr_newsletter;
      this.closeModal();
      this.params.goToPayment();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

.flex
  display: flex
  +max-mobile()
    flex-wrap: wrap
    justify-content: center;
  & > *
    width 100%
    padding-right: 0
    max-width 400px
    &.border
      border-style: none;
      +max-mobile()
        padding-left: 0
        border-left-width: 0
        border-top: 1px solid #bfd9e1
        margin-top 25px
        padding-top 25px
      .text
        text-align: left
        padding-top 15px

  &.use-login > *
    width 50%
    padding-right: 35px
    +max-mobile()
      width 100%
      padding-right: 0
    &.border
      border-left: 1px solid #bfd9e1
      padding-right: 0
      padding-left: 35px

.choices
  display: flex;
  margin-top 10px
  & > *
    margin-right: 20px

h2
  font-size: 20px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  uppercase()

hr
  height 1px
  background-color light-blue-grey
  margin-top 20px
  margin-bottom 20px

.modalo
  text-align center

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 10px
  text-align: left

  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.country-switcher
  margin-top 6px
</style>



// WEBPACK FOOTER //
// CheckoutLoginModal.vue?5caacade